import { Assignments } from "../types";
import { apiSlice } from "./api";

interface GetAssignmentsRequest {
  ventId: string;
}
export interface GetAssignmentsResponse {
  assignments: Assignments;
}

export interface DeleteAssignmentRequest {
  activityId: string;
  ventId: string;
  guestId: string;
}
// We get back all assignments so we get the most recent data.
// Other people may have updated their assignments since we last looked.
export interface DeleteAssignmentResponse {
  assignments: Assignments;
}

export interface UpsertAssignmentRequest {
  assignment: {
    quantity: number;
    comment: string;
  };
  activityId: string;
  ventId: string;
  guestId: string;
}
// We get back all assignments so we get the most recent data.
// Other people may have updated their assignments since we last looked.
// To avoid contention issue we don't rely on updateTime.
// Instead, we let the last updater win.
export interface UpsertAssignmentResponse {
  assignments: Assignments;
}

export const assignmentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignments: builder.query<
      GetAssignmentsResponse,
      GetAssignmentsRequest
    >({
      query: (body) => ({
        url: "getAssignments",
        body: JSON.stringify(body),
      }),
    }),

    upsertAssignment: builder.mutation<
      UpsertAssignmentResponse,
      UpsertAssignmentRequest
    >({
      query: (body) => ({
        url: "upsertAssignment",
        body: JSON.stringify(body),
      }),
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        const undos: any[] = []; // PatchCollection is not exposed
        try {
          const response = await queryFulfilled;
          undos.push(
            dispatch(
              assignmentsApi.util.updateQueryData(
                "getAssignments",
                { ventId: request.ventId },
                (draft) => {
                  draft.assignments = response.data.assignments;
                }
              )
            )
          );
        } catch (e) {
          console.log(e);
          for (const u of undos) {
            (u as any).undo();
          }
        }
      },
    }),

    deleteAssignment: builder.mutation<
      DeleteAssignmentResponse,
      DeleteAssignmentRequest
    >({
      query: (body) => ({
        url: "deleteAssignment",
        body: JSON.stringify(body),
      }),
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        const undos: any[] = []; // PatchCollection is not exposed
        try {
          const response = await queryFulfilled;
          undos.push(
            dispatch(
              assignmentsApi.util.updateQueryData(
                "getAssignments",
                { ventId: request.ventId },
                (draft) => {
                  draft.assignments = response.data.assignments;
                }
              )
            )
          );
        } catch (e) {
          console.log(e);
          for (const u of undos) {
            (u as any).undo();
          }
        }
      },
    }),
  }),
});

export const {
  useUpsertAssignmentMutation,
  useGetAssignmentsQuery,
  useDeleteAssignmentMutation,
} = assignmentsApi;
